import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticExportColumnSpecLookup from '../Models/Lookups/StaticExportColumnSpecLookup';
import { ColumnSpecDataTypeEnum } from '../../ColumnConfigurations/Models/Enums/ColumnSpecDataTypeEnum';

@NeoModel
export default class ManageColumnSpecComponentVM extends Views.ViewModelBase {

    constructor(
        public staticExportFileSpecApiClient =AppService.get(Types.ApiClients.StaticExportFileSpecApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }
    public managedExportColumnSpec = new StaticExportColumnSpecLookup();
    public isReadOnly: boolean = true;

    public async initialise(staticExportFileSpecId?: number, exportFileSpecProps?: string) {
        if (this.managedExportColumnSpec.staticExportColumnSpecId === 0) {
            this.managedExportColumnSpec.staticExportFileSpecId = Number(staticExportFileSpecId)!;
            this.managedExportColumnSpec.fileSpecPropertiesConcatenated = String(exportFileSpecProps);
        }
    }

    public setDateReadOnlyInd() {
        this.isReadOnly = this.managedExportColumnSpec.dataType !== ColumnSpecDataTypeEnum.Datetime;
    }
}